module.exports = __webpack_public_path__ + "img/twitch-lounge-gal-5.e41ecc77.jpg";